export const stock = {
	title: "STOCK",
	fields: {
		isStockable: {
			label: "Produit stockable?",
			placeholder: "Oui",
			tooltip:
				"Les produits stockables sont ceux qui sont conservés en stock jusqu'à ce qu'ils soient vendus ou utilisés.",
			options: {
				yes: "Oui",
				no: "Non",
			},
		},
		stockControlledBy: {
			label: "Stock contrôlé par:",
			placeholder: "Unités",
			options: {
				gram: "Grammes",
				kilogram: "Kilogrammes",
				liter: "Litres",
				milliliter: "Millilitres",
				unit: "Unités",
			},
		},
		conversionRule: {
			label: "Règle de conversion",
			tooltip:
				"Définissez comment les unités de vente se convertissent en unités de stock. Ex: 1 bouteille = 1 litre",
			unitLabel: "1 unité",
			equivalentTo: "équivaut à:",
		},
		conversionQuantity: {
			label: "Quantité",
			placeholder: "750",
		},
		conversionUnit: {
			label: "Unité de mesure",
			placeholder: "Millilitres",
			options: {
				gram: "Grammes",
				kilogram: "Kilogrammes",
				liter: "Litres",
				milliliter: "Millilitres",
			},
		},
	},
	messages: {
		nonStockableWarning:
			"Les produits non stockables <strong>n'apparaîtront pas dans les rapports de stock</strong>",
	},
};
